<template>
  <div class="m-section">
    <vue-content-loading
      v-if="isLoading"
      :width="300"
      :height="90"
      primary="#bdc3c7"
      secondary="#95a5a6"
    >
      <svg:rect x="0" y="0" rx="3" ry="3" width="90" height="8" />
      <svg:rect x="98" y="0" rx="3" ry="3" width="52" height="8" />
      <svg:rect x="190" y="0" rx="3" ry="3" width="110" height="8" />

      <svg:rect x="0" y="30" rx="3" ry="3" width="50" height="55" />
      <svg:rect x="60" y="30" rx="3" ry="3" width="50" height="55" />
      <svg:rect x="120" y="30" rx="3" ry="3" width="50" height="55" />
      <svg:rect x="180" y="30" rx="3" ry="3" width="50" height="55" />
      <svg:rect x="240" y="30" rx="3" ry="3" width="50" height="55" />
    </vue-content-loading>

    <template v-else>
      <div class="m-section__header">
        <div class="row justify-content-center align-items-center">
          <div class="col-md-9 col-12">
            <div class="m-section__headline">
              Tu nivel On Demand
              <span class="m-section__date ml-2" v-if="fortnightRange">
                {{ fortnightRange }}
              </span>
              <span class="m-section__date ml-2" v-if="fortnightWeeks">
                <strong>|</strong>&nbsp; {{ fortnightWeeks }}
              </span>
            </div>
          </div>
          <div class="col-md-3 col-12">
            <div class="text-right">
              <a class="link-download" @click="downloadPdf">
                ¿Cómo se calcula tu nivel de On Demand?
              </a>
            </div>
          </div>
        </div>
      </div>

      <LevelPaymentBetaNotice />

      <div class="row">
        <div class="col-md col-6">
          <LevelCard
            :period="period"
            :periods="getPeriods"
            :closed-periods="getClosedPeriods"
            :thresholds="getThresholds"
            :cutoffs="getCutoffs"
            @open="goToLevels"
          />
        </div>

        <div class="col-md col-6" v-for="threshold in getThresholds" :key="threshold.metric">
          <MetricCard :threshold="threshold" :period="period" :cutoffs="getCutoffs" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import { VueContentLoading } from 'vue-content-loading';
import { mapGetters } from 'vuex';
import LevelCard from './OnDemandLevel/LevelCard';
import MetricCard from './OnDemandLevel/MetricCard';
import LevelPaymentBetaNotice from '../Levels/LevelPaymentBetaNotice';

const LEVELS_ROUTE = '/foodcourt/niveles';
const PDF_PATH = '/document/Niveles_on_demand.pdf';
const PDF_NAME = 'Niveles On Demand.pdf';
const DAY_MONTH_FORMAT = 'DD/MM';

export default {
  name: 'OnDemandLevel',
  components: { VueContentLoading, LevelCard, MetricCard, LevelPaymentBetaNotice },
  computed: {
    ...mapGetters('foodcourtLevels', [
      'getPeriods',
      'getClosedPeriods',
      'getLastClosedRatedPeriod',
      'getThresholds',
      'getCutoffs'
    ]),
    isLoading() {
      return this.getPeriods === null;
    },
    period() {
      return this.getLastClosedRatedPeriod;
    },
    fortnightRange() {
      if (this.period === null) {
        return '';
      }

      return `Del ${this.dayMonth(this.period.start_date)} al ${this.dayMonth(
        this.period.end_date
      )}`;
    },
    fortnightWeeks() {
      if (this.period === null) {
        return '';
      }

      const startWeek = this.week(this.period.start_date);
      const endWeek = this.week(this.period.end_date);

      return startWeek === endWeek
        ? `Semana ${startWeek}`
        : `Semanas ${startWeek} a ${endWeek}`;
    }
  },
  methods: {
    dayMonth(date) {
      return moment(date).format(DAY_MONTH_FORMAT);
    },
    week(date) {
      return moment(date).isoWeek();
    },
    goToLevels() {
      this.$router.push(LEVELS_ROUTE);
    },
    downloadPdf() {
      const link = document.createElement('a');
      link.href = PDF_PATH;
      link.download = PDF_NAME;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style lang="scss" scoped>
.level-card {
  cursor: pointer;
}
</style>
